import _ from 'lodash'

import { Space } from '../../../../components/core-v2'
import { useAppSelector } from '../../store/hooks'
import {
  ProposedChangesModalRestrictions,
  RestrictionsData
} from './proposed-changes-modal-restrictions'

export const ProposedChangesRestrictionsTabContent = () => {
  const state = useAppSelector(state => state.editPortfolios)

  const currentData: RestrictionsData = {
    allowedBusinessUnitIds: _.cloneDeep(state.selectedPortfolio?.allowedBusinessUnitIds || []),
    clients: _.cloneDeep(state.allClients),
    usage: _.cloneDeep(state.selectedPortfolioUsage)
  }

  const proposedData: RestrictionsData = {
    allowedBusinessUnitIds: _.cloneDeep(
      state.selectedPortfolio?.pendingChange?.auditedPortfolioData?.allowedBusinessUnitIds ||
        state.selectedPortfolio?.allowedBusinessUnitIds ||
        []
    ),
    clients: _.cloneDeep(state.allClients),
    usage: _.cloneDeep(state.selectedPortfolioUsage)
  }

  return (
    <Space flexDirection="column" mt={5}>
      <ProposedChangesModalRestrictions currentData={currentData} proposedData={proposedData} />
    </Space>
  )
}
